import './Footer.css';

const Footer = () => {
    const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    const sections = [
        { label: 'Overview', id: 'overview' },
        { label: 'Collage', id: 'collage' },
        { label: 'Timeline', id: 'timeline' },
        { label: 'Legacy', id: 'quote' },
    ];

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <footer className="footer">
            <div className="footer__top">
                <div className="footer__brand">
                    <div className="footer__logo">
                        <span className="footer__logo-crescent">☽</span>
                        <span className="footer__logo-text">Salah Eldin El-Ayoubi</span>
                    </div>
                    <p className="footer__tagline">
                        Sultan of Egypt &amp; Syria · Founder of the Ayyubid Dynasty<br />
                        Liberator of Jerusalem · The Honorable
                    </p>
                    <div className="footer__arabic">صلاح الدين الأيوبي</div>
                </div>

                <div className="footer__nav">
                    <h4 className="footer__nav-title">Explore</h4>
                    <ul className="footer__nav-list">
                        {sections.map((s) => (
                            <li key={s.id}>
                                <button className="footer__nav-link" onClick={() => scrollTo(s.id)}>
                                    {s.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="footer__facts">
                    <h4 className="footer__nav-title">Key Dates</h4>
                    <ul className="footer__dates-list">
                        <li><span className="footer__date-year">1137</span><span>Born in Tikrit</span></li>
                        <li><span className="footer__date-year">1169</span><span>Became Vizier</span></li>
                        <li><span className="footer__date-year">1174</span><span>Sultan of Egypt &amp; Syria</span></li>
                        <li><span className="footer__date-year">1187</span><span>Liberation of Jerusalem</span></li>
                        <li><span className="footer__date-year">1193</span><span>Returned to God's Mercy</span></li>
                    </ul>
                </div>
            </div>

            <div className="footer__divider">
                <span className="footer__divider-ornament">✦ ✦ ✦</span>
            </div>

            <div className="footer__bottom">
                <p className="footer__copy">
                    © 2025 · <span className="footer__gold">Historical Tribute</span> · Salah Eldin El-Ayoubi
                </p>
                <button className="footer__back-top" onClick={scrollTop} aria-label="Back to top">
                    ↑ <span>Back to Top</span>
                </button>
            </div>
        </footer>
    );
};

export default Footer;
